/**
 * The preview's URL space and messages, shared by the editor (which builds a
 * preview), the preview service worker (which serves it) and the pages it
 * serves.
 *
 *   /_preview/<site>/building?build=<token>  waiting page, opened at click
 *   /_preview/<site>/build/<token>            that build's result (JSON)
 *   /_preview/<site>/<rev>/<path>             a revision's files
 *   /_preview/<site>/<rev>/_assets/<sha>      the site's media (OPFS)
 *
 * Every page of a revision is rendered with base `/_preview/<site>/<rev>/`, so
 * its links, stylesheet and media never leave that revision.
 */
export const PREVIEW_ROOT = "/_preview/";

/** The service worker's script path (dev and prod). */
export const PREVIEW_SW_URL = "/preview-sw.js";

/** Site and draft ids as they appear in URLs (uuid or local-<uuid>). */
export const SITE_ID_RE = /^[A-Za-z0-9_-]{1,80}$/;
export const BUILD_TOKEN_RE = /^[a-z0-9]{8,40}$/;

export const previewBase = (site: string, rev: string): string =>
  `${PREVIEW_ROOT}${site}/${rev}/`;

export const buildingUrl = (site: string, token: string): string =>
  `${PREVIEW_ROOT}${site}/building?build=${token}`;

export const buildResultUrl = (site: string, token: string): string =>
  `${PREVIEW_ROOT}${site}/build/${token}`;

/** Where the editor announces that previews moved to a new revision. */
export const channelName = (site: string): string => `wb-preview:${site}`;

/** What a build left for the waiting page to pick up. */
export type BuildResult =
  | { readonly ok: true; readonly rev: string }
  | { readonly ok: false; readonly error: string };

/** Posted on {@link channelName} after previews switch revision. */
export interface SwitchedMessage {
  readonly type: "switched";
  readonly rev: string;
}
